import { render, staticRenderFns } from "./DropDown.vue?vue&type=template&id=28f84f53&scoped=true"
import script from "./DropDown.vue?vue&type=script&lang=js"
export * from "./DropDown.vue?vue&type=script&lang=js"
import style0 from "./DropDown.vue?vue&type=style&index=0&id=28f84f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f84f53",
  null
  
)

export default component.exports